<template>
  <b-form-checkbox-group
    :options="options"
    v-model="innerValue"
    stacked
    class="fields-picker"
  />
</template>

<script>
export default {
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    innerValue: {
      get: ({ value }) => value,
      set: function(val) {
        this.$emit(
          "input",
          this.fields.filter(field => val.includes(field))
        );
      }
    },
    options: ({ fields }) =>
      fields.map(field => ({
        text: field.label,
        value: field,
        disabled: false
      }))
  },
  created() {
    if (this.value.length === 0) this.$emit("input", this.fields);
  }
};
</script>

<style>
.fields-picker {
  margin-left: 5px;
}
</style>
